import React from "react";
import { Fade } from "react-awesome-reveal";
import pimg1 from '../../../images/brand/azure.png'
import pimg2 from '../../../images/brand/gcp.png'
import pimg3 from '../../../images/brand/aws.png'

const partners = [
    { pImg: pimg1, alt: 'Microsoft Azure', width: 180 },
    { pImg: pimg2, alt: 'Google Cloud Platform', width: 180 },
    { pImg: pimg3, alt: 'Amazon Web Services', width: 120 },
];

/* eslint-disable no-unused-vars */

const PartnerSection = () => {
    return (
        <section className="partner-section-modern">
            <div className="container">
                <Fade direction="up" triggerOnce={true} duration={800}>
                    <p className="partner-title">Integrates with leading cloud providers</p>
                </Fade>

                <Fade direction="up" triggerOnce={true} duration={1000} delay={200}>
                    <div className="partner-logo-wrap">
                        {partners.map((partner, index) => (
                            <div
                                key={index}
                                className="partner-logo-item"
                                style={{
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                            >
                                <img
                                    src={partner.pImg}
                                    alt={partner.alt}
                                    style={{
                                        width: partner.width,
                                        height: 'auto',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </Fade>
            </div>
        </section>
    );
};

export default PartnerSection;
